<template>
  <BlankPage :status="pageStatus" />
</template>

<script>
import comService from '@/services/comService';
import rmuService from '@/services/rmuService';
import BlankPage from '@/components/BlankPage.vue';

export default {
  components: {
    BlankPage,
  },
  data() {
    return {
      pageStatus: 'blank',
    };
  },
  created() {
    const vm = this;

    const {
      companyId, redirectUri, code, companyTagNo, menuObjectNo,
    } = vm.$route.query;

    // 取得 Line UserId 後，處理貼標與點擊紀錄並導頁
    vm.getLineUserId(companyId, redirectUri, code, companyTagNo, menuObjectNo)
      .then((userId) => {
        let tagPromise = Promise.resolve();
        let clickedPromise = Promise.resolve();

        // 有 companyTagNo 做貼標
        if (companyTagNo) {
          tagPromise = vm.postMemberTag(companyId, userId, companyTagNo, redirectUri);
        }
        // 有 menuObjectNo 做點擊紀錄
        if (menuObjectNo) {
          clickedPromise = rmuService.createQRCodeMessageClick({ accountId: userId, menuObjectNo: parseInt(menuObjectNo, 10) }).toPromise();
        }

        return Promise.all([tagPromise, clickedPromise]);
      })
      .finally(() => {
        // 導頁
        window.location.replace(redirectUri);
      });
  },
  methods: {
    // 取得 Line UserId
    getLineUserId(companyId, redirectUri, code, companyTagNo, menuObjectNo) {
      const params = new URLSearchParams({ companyId, redirectUri });

      // 有companyTagNo才新增
      if (companyTagNo) {
        if (Array.isArray(companyTagNo)) {
          companyTagNo.forEach((tagNo) => {
            params.append('companyTagNo', tagNo);
          });
        } else {
          params.append('companyTagNo', companyTagNo);
        }
      }

      // 有menuObjectNo才新增
      if (menuObjectNo) {
        params.append('menuObjectNo', menuObjectNo);
      }

      const redirectQueryString = params.toString();
      const directUrl = `${window.location.origin}${window.location.pathname}?${redirectQueryString}`;
      const body = {
        companyId,
        code,
        directUrl,
      };

      return comService.getLineUserId(body)
        .toPromise()
        .then((res) => res.response.data.userID)
        .catch(() => {
          this.$router.replace({ name: 'Error', params: { status: 'authorization' } });
        });
    },
    // 會員貼標
    postMemberTag(companyId, accountId, companyTagNo, redirectUri) {
      const tagNos = Array.isArray(companyTagNo) ? companyTagNo : [companyTagNo];
      return this.$store.dispatch('mbc/postMemberTag', {
        companyId,
        accountType: 'LineBind',
        accountId,
        createUser: 'System',
        source: 'RichMenuUri',
        sourceRemark: redirectUri.substring(0, 100),
        companyTagNo: tagNos.map((x) => parseInt(x, 10)),
      });
    },
  },
};
</script>
